import { useTranslation } from 'react-i18next';
import { StarFilledIcon, StarOutlineIcon } from '@components/Pages/IssuesPage/Board/icons';
import { Tooltip } from '@components/ui/Tooltip/Tooltip';
import styles from './CriticalStar.module.css';

interface ICriticalStarProps {
  critical: boolean;
  /** Stars or unstars the order. Absent (a viewer, a locked board, a synced
   *  order), the star only reads, and a regular order shows nothing. */
  onToggle?: () => void;
  className?: string;
}

/** A delivery order's critical mark: the Issues star, same look and copy. */
export function CriticalStar({ critical, onToggle, className = '' }: ICriticalStarProps) {
  const { t } = useTranslation();
  const icon = critical ? <StarFilledIcon size={18} /> : <StarOutlineIcon size={18} />;
  if (!onToggle) {
    if (!critical) return null;
    return (
      <Tooltip content={t('activities.filter.critical')}>
        <span role="img" className={`${styles.star} ${className}`} data-critical="true" aria-label={t('activities.filter.critical')}>
          {icon}
        </span>
      </Tooltip>
    );
  }
  const label = t(critical ? 'issues.hub.removeCritical' : 'issues.hub.markCritical');
  return (
    <Tooltip content={label}>
      <button
        type="button"
        className={`${styles.star} ${styles.toggle} ${className}`}
        data-critical={critical}
        aria-pressed={critical}
        aria-label={label}
        onClick={onToggle}
      >
        {icon}
      </button>
    </Tooltip>
  );
}
